import authFetch from './fetch';
import qs from 'qs';
import { getQueryParams, makeRequest } from './utils';
import { useQuery } from '@tanstack/react-query';
import { CacheConfig } from './consts';

export const getOrders = async (search) => {
  try {
    const { data } = await authFetch.get(
      `/api/orders?${search && Object.keys(search).length ? qs.stringify(search) : ''}`,
    );
    return Promise.resolve(data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getOrder = (pronumber) => makeRequest(authFetch.get(`/api/Orders/${pronumber}`));

export const getOrdersGridTwds = async (search = {}) => {
  try {
    const { data } = await authFetch.get(
      `/api/orders/grid/TwoWeeksDeliverySchedule?${search && Object.keys(search).length ? qs.stringify(search) : ''}`,
    );
    return Promise.resolve(data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getOrdersGridStatusTracker = async (search = {}) => {
  try {
    const { data } = await authFetch.get(
      `/api/orders/grid/StatusTracker?${search && Object.keys(search).length ? qs.stringify(search) : ''}`,
    );
    return Promise.resolve(data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getOrdersGridBookingTracker = async (search = {}) => {
  try {
    const { data } = await authFetch.get(
      `/api/orders/grid/BookingTracker?${search && Object.keys(search).length ? qs.stringify(search) : ''}`,
    );
    return Promise.resolve(data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getOrdersGrid = async (search = {}) => {
  try {
    const { data } = await authFetch.get(
      `/api/orders/grid?${search && Object.keys(search).length ? qs.stringify(search) : ''}`,
    );
    return Promise.resolve(data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getClaimsOrdersLookup = async (search) => makeRequest(authFetch.get(`/api/claims/order-equipment-details${getQueryParams(search)}`));

export const getWarehouseDetailGrid = (params) => makeRequest(authFetch.get(`/api/orders/Grid/WarehouseDetail${getQueryParams(params)}`));

export const postOrder = async (order) => makeRequest(authFetch.post('/api/orders', order));

export const postImportTracing = async (tracing, pronumber) => {
  try {
    const response = await authFetch.post(`/api/orders/${pronumber}/Importtracing`, tracing);
    return Promise.resolve(response);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const postExportTracing = async (tracing, pronumber) => {
  try {
    const response = await authFetch.post(`/api/orders/${pronumber}/Exporttracing`, tracing);
    return Promise.resolve(response);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const bulkUpdateOrders = (changes) => makeRequest(authFetch.patch('/api/orders/BulkUpdate', changes));

export const getOrderLegStopTypes = async () => {
  try {
    const { data } = await authFetch.get('/api/orders/OrderLegStopTypes');
    return Promise.resolve(data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const useGetOrderLegStopTypes = () => useQuery(['orderLegStopTypes'], getOrderLegStopTypes, CacheConfig.forever);

export const createMasterOrderFromQuote = async (quoteId, quoteLaneRateId) => makeRequest(authFetch.post(`/api/MasterOrders/CreateMasterOrderFromQuote/${quoteId}/${quoteLaneRateId}`));

export const postMasterOrder = async (masterOrder) => {
  try {
    const { data } = await authFetch.post('/api/MasterOrders', { ...masterOrder });
    return Promise.resolve(data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const createMasterOrderFromOrder = async (proNumber) => makeRequest(authFetch.post(`/api/MasterOrders/CreateMasterOrderFromOrder/${proNumber}`));

export const getDefaultLocations = async (quoteLaneRateId) => {
  try {
    const { data } = await authFetch.get(`/api/MasterOrders/GetDefaultLocations?QuoteLaneRateId=${quoteLaneRateId}`);
    return Promise.resolve(data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const sequenceOrderLegs = async (legs) => {
  try {
    const { data } = await authFetch.post('/api/orders/SequenceOrderLegs', legs);
    return Promise.resolve(data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const refreshLegStatuses = async (leg) => {
  try {
    const { data } = await authFetch.post('/api/orders/RefreshLegStatuses', { Leg: leg });
    return Promise.resolve(data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getTargetDeliveryDateTypes = async () => {
  try {
    const { data } = await authFetch.get('/api/Orders/TargetDeliveryDateTypes');
    return Promise.resolve(data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const useGetTargetDeliveryDateTypes = () => useQuery(['targetDeliveryDateTypes'], getTargetDeliveryDateTypes, CacheConfig.forever);

export const getMoveTypes = async () => {
  try {
    const { data } = await authFetch.get('/api/Orders/MoveTypes');
    return Promise.resolve(data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const useGetMoveTypes = () => useQuery(['moveTypes'], getMoveTypes, CacheConfig.forever);

export const getOrderModes = async () => {
  try {
    const { data } = await authFetch.get('/api/Orders/OrderModes');
    return Promise.resolve(data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const useGetOrderModes = () => useQuery(['orderModes'], getOrderModes, CacheConfig.forever);

export const getReferenceNumberTypes = async () => {
  try {
    const { data } = await authFetch.get('/api/Orders/ReferenceNumberTypes');
    return Promise.resolve(data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getChassisPools = async () => {
  try {
    const { data } = await authFetch.get('/api/Orders/ChassisPools');
    return Promise.resolve(data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getMasterOrderVisiblePropertiesInventory = async (moveTypes, deliveryType) => {
  try {
    const { data } = await authFetch.get(
      `/api/MasterOrders/VisiblePropertiesInventory?moveTypes=${moveTypes}&deliveryType=${deliveryType}`,
    );
    return Promise.resolve(data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getOrderVisiblePropertiesInventory = async (moveType, quoteId, mode, quoteLaneRateId, billToId) => {
  try {
    const { data } = await authFetch.get(
      `/api/Orders/VisiblePropertiesInventory?moveType=${moveType}&quoteId=${quoteId}&mode=${mode}&quoteLaneRateId=${quoteLaneRateId}&billToId=${billToId}`,
    );
    return Promise.resolve(data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const validateEquipmentNumber = async (equipmentNumber) => {
  try {
    const { data } = await authFetch.post(
      `/api/Orders/ValidateEquipmentNumber${equipmentNumber ? `?equipmentNumber=${equipmentNumber}` : ''}`,
    );
    return Promise.resolve(data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getDistanceBetweenAddresses = async (origin, destination) => {
  try {
    const { data } = await authFetch.get(
      `/api/Orders/GetDistanceBetweenAddresses?Origin=${origin || ''}&Destination=/${destination || ''}`,
    );
    return Promise.resolve(data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getOrderStatuses = async () => {
  try {
    const { data } = await authFetch.get('/api/Orders/OrderStatuses');
    return Promise.resolve(data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const useGetOrderStatuses = () => useQuery(['orderStatuses'], getOrderStatuses, CacheConfig.forever);

export const getOrdersDashboard = async (ids) => {
  const queryString = ids && ids.map((i) => `&logisticsCoordinatorIds=${i}`).join('');
  try {
    const response = await authFetch.get(`/api/orders/dashboard?${queryString}`);
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getAvailabilityTypes = async () => {
  try {
    const response = await authFetch.get('/api/orders/AvailableFilterOptions');
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const useGetAvailabilityTypes = () => useQuery(['availabilityTypes'], getAvailabilityTypes, CacheConfig.forever);

export const updateWaitingTime = async (leg) => {
  try {
    const response = await authFetch.post('/api/orders/UpdateWaitingTime', leg);
    return Promise.resolve(response);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getWaitingTime = async (search) => {
  try {
    const response = await authFetch.get(
      `/api/orders/GetWaitingTime?${search && Object.keys(search).length ? qs.stringify(search) : ''}`,
    );
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getCarriers = async () => {
  try {
    const response = await authFetch.get('/api/ExternalCarriers');
    return Promise.resolve(response.data.map((c) => ({ text: c.carrierName, value: c.id, ...c })));
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const useGetCarriers = () => useQuery(['carriers'], getCarriers, CacheConfig.forever);

export const postCarrier = async (data) => {
  try {
    const response = await authFetch.post('/api/ExternalCarriers', data);
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getBookingHoldTypes = async () => {
  try {
    const response = await authFetch.get('/api/orders/BookingHoldTypes');
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const useGetBookingHoldTypes = () => useQuery(['bookingHoldTypes'], getBookingHoldTypes, CacheConfig.forever);

export const getBookingHoldFaultTypes = async () => makeRequest(authFetch.get('/api/orders/BookingHoldFaultTypes'));
export const useGetBookingHoldFaultTypes = () => useQuery(['bookingHoldFaultTypes'], getBookingHoldFaultTypes, CacheConfig.forever);

export const getInbondTypes = async () => {
  try {
    const { data } = await authFetch.get('/api/Orders/InbondTypes');
    return Promise.resolve(data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const useGetInbondTypes = () => useQuery(['inbondTypes'], getInbondTypes, CacheConfig.forever);

export const getRailbillStatusTypes = async () => {
  try {
    const { data } = await authFetch.get('/api/Orders/RailbillStatus');
    return Promise.resolve(data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getResponsiblePartyTypes = async () => {
  try {
    const { data } = await authFetch.get('/api/Orders/ResponsibleParty');
    return Promise.resolve(data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const useGetResponsibilityPartyTypes = () => useQuery(['responsiblePartyTypes'], getResponsiblePartyTypes, CacheConfig.forever);

export const getTemperatureScaleTypes = async () => {
  try {
    const { data } = await authFetch.get('/api/Orders/TemperatureScale');
    return Promise.resolve(data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const useGetTemperatureScaleTypes = () => useQuery(['temperatureScaleTypes'], getTemperatureScaleTypes, CacheConfig.forever);

export const getVentSettingTypes = async () => {
  try {
    const { data } = await authFetch.get('/api/Orders/VentSetting');
    return Promise.resolve(data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getOrderTracing = async (proNumber) => {
  try {
    const { data } = await authFetch.get(`/api/Tracing/OrderInformation?ProNumber=${proNumber}`);
    return Promise.resolve(data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const executeTrace = async (tracingData) => {
  try {
    const { data } = await authFetch.post('/api/Tracing/Trace', tracingData);
    return Promise.resolve(data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getOrderHistory = async (proNumber) => {
  try {
    const { data } = await authFetch.get(`/api/Orders/Audits?ProNumber=${proNumber}`);
    return Promise.resolve(data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getOrderProfit = async (proNumber) => {
  try {
    const { data } = await authFetch.get(`/api/Orders/${proNumber}/Profitability`);
    return Promise.resolve(data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getOrderReschedule = async (proNumber) => {
  try {
    const { data } = await authFetch.get(`/api/Orders/Reschedule?ProNumber=${proNumber}`);
    return Promise.resolve(data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const postOrderReschedule = async (data) => {
  try {
    const response = await authFetch.post('/api/Orders/Reschedule', data);
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getRescheduleSourceType = async () => {
  try {
    const { data } = await authFetch.get('/api/Orders/SourceType');
    return Promise.resolve(data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getRescheduleFaultType = async () => {
  try {
    const { data } = await authFetch.get('/api/Orders/OrderRescheduleFaultType');
    return Promise.resolve(data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const validateProNumber = async (pro) => {
  try {
    const { data } = await authFetch.get(`/api/Orders/ValidateProNumber?ProNumber=${pro}`);
    return Promise.resolve(data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getOrderInvoicing = async (proNumber, request = {}) => {
  try {
    const { data } = await authFetch.get(`/api/Orders/${proNumber}/Invoicing${getQueryParams(request)}`);
    return Promise.resolve(data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const postOrderInvoicing = async (values) => {
  try {
    const { data } = await authFetch.post('/api/Orders/Invoicing', values);
    return Promise.resolve(data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const updateOrderApprovals = async (approval) => {
  try {
    const { data } = await authFetch.post('/api/Orders/UpdateApprovals', approval);
    return Promise.resolve(data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getOrderAudits = (id, params) => makeRequest(authFetch.get(`/api/Orders/${id}/Audits${getQueryParams(params)}`));
export const getOrderAuditProperties = (id) => makeRequest(authFetch.get(`/api/Orders/${id}/Audits/Properties`));

export const getOrderAuditUsers = (id) => makeRequest(authFetch.get(`/api/Orders/${id}/Audits/Users`));

export const getOrderFiles = async (proNumber, params) => {
  try {
    const response = await authFetch.get(`/api/Orders/${proNumber}/Files${getQueryParams(params)}`);
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const updateOrderFileInfo = async (proNumber, fileId, info) => {
  try {
    const response = await authFetch.put(`/api/Orders/${proNumber}/Files/${fileId}`, info);
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const postOrderFiles = async (proNumber, files) => makeRequest(authFetch.post(`/api/Orders/${proNumber}/Files`, files));

export const deleteOrderFile = (proNumber, fileId) => makeRequest(authFetch.delete(`/api/Orders/${proNumber}/Files/${fileId}`));

export const getExportWarehouseInformation = (proNumber) => makeRequest(authFetch.get(`/api/Orders/${proNumber}/Export/Warehouse`));
export const getImportWarehouseInformation = (proNumber) => makeRequest(authFetch.get(`/api/Orders/${proNumber}/Import/Warehouse`));
export const upsertExportWarehouseInformation = (data) => makeRequest(authFetch.put(`/api/Orders/${data.proNumber}/Export/Warehouse`, data));
export const upsertImportWarehouseInformation = (data) => makeRequest(authFetch.put(`/api/Orders/${data.proNumber}/Import/Warehouse`, data));
export const getOrderDocumentTypes = () => makeRequest(authFetch.get('/api/Orders/DocumentTypes'));
export const getHoldTypes = () => makeRequest(authFetch.get('/api/Orders/HoldTypes'));
export const getAddToBLTypes = () => makeRequest(authFetch.get('/api/Orders/AddToBLTypes'));
export const getPickPolicies = () => makeRequest(authFetch.get('/api/Orders/PickPolicies'));
export const addToFavourites = (orderId) => makeRequest(authFetch.post(`/api/orders/favourites/${orderId}`));
export const removeFromFavourites = (orderId) => makeRequest(authFetch.delete(`/api/orders/favourites/${orderId}`));
export const getFavouritesOrders = (params) => makeRequest(authFetch.get(`/api/orders/favourites${getQueryParams(params)}`));

export const getTracingCustomStatuses = () => makeRequest(authFetch.get('/api/Orders/TracingCustomStatuses'));
export const getInvoicingHoldsReasons = () => makeRequest(authFetch.get('/api/Orders/InvoicingHoldsReasons'));
export const getTracingLineStatuses = () => makeRequest(authFetch.get('/api/Orders/TracingLineStatuses'));
export const getDeliveryOrderReport = (proNumber) => makeRequest(authFetch.get(`/api/CMSv2/TelerikReports/DeliveryOrderReport/${proNumber}`));
export const getMaterialReport = (proNumber) => makeRequest(authFetch.get(`/api/CMSv2/TelerikReports/MaterialReceiptReports/${proNumber}`));

export const getBillOfLading = (proNumber) => makeRequest(authFetch.get(`/api/CMSv2/TelerikReports/BillOfLading/${proNumber}`));
export const getDispatchPaperworkReport = (orderLegId) => makeRequest(authFetch.get(`/api/CMSv2/TelerikReports/DispatchPaperworkReport/${orderLegId}`));
export const getReportVersion = () => makeRequest(authFetch.get('/api/CMSv2/TelerikReports/version'));
export const getOrderTypes = () => makeRequest(authFetch.get('/api/Orders/OrderTypes'));
export const useGetOrderTypes = () => useQuery(['orderTypes'], getOrderTypes, CacheConfig.forever);

export const getInvoiceAccessorials = (proNumber) => makeRequest(authFetch.get(`/api/Orders/${proNumber}/Invoicing/Accessorials`));
export const getLineItemTypes = () => makeRequest(authFetch.get('/api/Orders/LineItemTypes'));
export const useGetLineItemTypes = () => useQuery(['lineItemTypes'], getLineItemTypes, CacheConfig.forever);
export const getChargeIntervals = () => makeRequest(authFetch.get('/api/Orders/ChargeIntervals'));
export const upsertInvoiceAccessorial = (acc, options) => makeRequest(authFetch.post(`/api/Orders/${acc.proNumber}/Invoicing/Accessorials`, acc, options));
export const getRequiredDocumentStatuses = () => makeRequest(authFetch.get('/api/Orders/RequiredDocumentStatuses'));
export const getAdditionalCostsGrid = (proNumber) => makeRequest(authFetch.get(`/api/Orders/${proNumber}/AdditionalCosts/grid`));
export const getAdditionalCost = (id) => makeRequest(authFetch.get(`/api/Orders/AdditionalCosts/${id}`));
export const upsertAdditionalCost = (acc, options) => makeRequest(authFetch.post('/api/Orders/AdditionalCosts/', acc, options));
export const getOrderAdditionalCostTypes = () => makeRequest(authFetch.get('/api/Orders/OrderAdditionalCostTypes'));
export const getOrderAdditionalCostStatuses = () => makeRequest(authFetch.get('/api/Orders/OrderAdditionalCostStatuses'));
export const getOrderAdditionalCostLineItemPayStatuses = () => makeRequest(authFetch.get('/api/Orders/OrderAdditionalCostLineItemPayStatuses'));
export const getOrderAdditionalCostLineItemDepartments = () => makeRequest(authFetch.get('/api/Orders/OrderAdditionalCostLineItemDepartments'));
export const getOrderAdditionalCostLineItemReasons = () => makeRequest(authFetch.get('/api/Orders/OrderAdditionalCostLineItemReasons'));
export const getMasterOrderDocumentTypes = () => makeRequest(authFetch.get('/api/MasterOrders/FileTypes'));
export const exportMainOrderGrid = (searchParams) => makeRequest(authFetch.get(`/api/Orders/Grid/Excel${getQueryParams(searchParams)}`));
export const duplicateV1Order = (id, request) => makeRequest(authFetch.post(`/api/Orders/${id}/duplicate`, request));
export const getPickListReport = (proNumber) => makeRequest(authFetch.get(`/api/CMSv2/TelerikReports/PickListReport/${proNumber}`));
export const getWarehouseItemLabelsReport = (proNumber) => makeRequest(authFetch.get(`/api/CMSv2/TelerikReports/WarehouseLineItemLabelsReport/${proNumber}`));
export const getExcelReport = async (filter) => makeRequest(authFetch.post('/api/CMSv2/TelerikReports/Excel', filter));
export const getExcelReportWithScheduledReportId = async (id) => makeRequest(authFetch.post(`/api/CMSv2/TelerikReports/Excel/${id}`));
export const getBillFrom = () => makeRequest(authFetch.get('/api/orders/billFrom'));
export const getInvoiceCancellationReasons = () => makeRequest(authFetch.get('/api/orders/invoiceCancellationReasons'));
export const cancelOrder = (proNumber) => makeRequest(authFetch.patch(`/api/orders/${proNumber}/cancel`));

export const getOrdersToAcknowledge = (request) => makeRequest(authFetch.post('/api/ordersAcknowledgement/ordersToAcknowledge', request));
export const getPerDiemPastDueAcknowledgeReasons = () => makeRequest(authFetch.get('/api/ordersAcknowledgement/reasons'));
export const acknowledgeOrders = (requests) => makeRequest(authFetch.put('/api/ordersAcknowledgement', requests));

export const getOrderNotes = (id, params) => makeRequest(authFetch.get(`/api/Orders/${id}/notes${getQueryParams(params)}`));
export const patchOrderNote = (id, note) => makeRequest(authFetch.patch(`/api/Orders/${id}/notes`, note));

export const getOrderChassisUsage = (proNumber) => makeRequest(authFetch.get(`/api/Orders/${proNumber}/chassisUsage`));
export const getOrderBulkUpdateProperties = () => makeRequest(authFetch.get('/api/Orders/BulkUpdate/Properties'));
export const useGetOrderBulkUpdateProperties = () => useQuery(['orderBulkUpdateProperties'], getOrderBulkUpdateProperties, CacheConfig.forever);

// Order invoice
export const markOrderAsReadyToInvoce = (id) => makeRequest(authFetch.patch(`/api/Orders/${id}/markAsReadyToInvoice`));
export const recallOrderInvocing = (id) => makeRequest(authFetch.patch(`/api/Orders/${id}/recall`));
export const cancelOrdersInvoices = (request) => makeRequest(authFetch.patch('/api/Orders/cancelOrdersInvoices', request));

export const searchOrders = (request) => makeRequest(authFetch.post('/api/Orders/CustomSearch', request));

// Orders with Journeys
export const getOrderDetails = (proNumber) => makeRequest(authFetch.get(`/api/Orders/${proNumber}/journey`));

export const postOrderWithJourneys = (data) => makeRequest(authFetch.post('/api/Orders/journeys', data));

// Order Leg Driver Pay Details
export const getDriverPayDetailsByLeg = (proNumber, legId) => makeRequest(authFetch.get(`api/Orders/${proNumber}/legs/${legId}/driverPayDetails`));

export const setPaymentRequirementStatus = ({
  proNumber, legId, type, data,
}) => makeRequest(authFetch.patch(`api/Orders/${proNumber}/legs/${legId}/paymentRequirements/${type}/state`, data));

export const uploadPaymentRequirementFile = ({
  proNumber, legId, type, file,
}) => makeRequest(authFetch.patch(`api/Orders/${proNumber}/legs/${legId}/paymentRequirements/${type}/file`, file));

export const getPaymentRequirementStatuses = () => makeRequest(authFetch.get('api/Orders/paymentRequirements/statuses'));

// Send to driver
export const sendJourneyToDriver = ({ proNumber, journeyId }) => makeRequest(authFetch.patch(`api/Orders/${proNumber}/journeys/${journeyId}/sentToDriver`));

// waiting times
export const WaitingTimePayStatusLookup = () => makeRequest(authFetch.get('api/Orders/WaitingTimePayStatus'));

export const getLegWaitingTime = (legId) => makeRequest(authFetch.get(`api/Orders/legs/${legId}/WaitingTime`));

export const postWaitingTime = (data) => makeRequest(authFetch.post('api/Orders/legs/WaitingTime', data));

export const deleteWaitingTime = (id) => makeRequest(authFetch.delete(`api/Orders/legs/WaitingTime/${id}`));

export const getAuditSummary = (proNumber) => makeRequest(authFetch.get(`api/Orders/${proNumber}/AuditSummary`));

// Street turn
export const getStreetTurnProNumbers = (proNumber) => makeRequest(authFetch.get(`api/Orders/${proNumber}/StreetTurns`));

export const validateStreetTurn = ({ proNumber, streetTurnProNumber }) => makeRequest(authFetch.get(`api/Orders/${proNumber}/StreetTurns/${streetTurnProNumber}`));

export const createStreetTurn = ({ proNumber, streetTurnProNumber }) => makeRequest(authFetch.post(`api/Orders/${proNumber}/StreetTurns/${streetTurnProNumber}`));

export const updateAccessorialToPendingInvoicing = (proNumber, accessorialId) => makeRequest(authFetch.patch(`api/Orders/${proNumber}/Invoicing/Accessorials/${accessorialId}/readyToInvoice`));

export const recallAccessorial = (proNumber, accessorialId) => makeRequest(authFetch.patch(`api/Orders/${proNumber}/Invoicing/Accessorials/${accessorialId}/recall`));

export const setInvoicingStatusToPaid = (proNumber) => makeRequest(authFetch.patch(`api/Orders/${proNumber}/setInvoicingStatusToPaid`));

export const getOrderInvoicingStatuses = () => makeRequest(authFetch.get('api/Orders/OrderInvoicingStatuses'));
export const autoEmailRollingCutNoContainerApplied = (request) => makeRequest(authFetch.post('api/Orders/autoEmailRollingCutNoContainerApplied', request));

// Scheduling History
export const getSchedulingHistory = (params) => makeRequest(
  authFetch.get(`api/SchedulingHistory${getQueryParams(params)}`),
);

export const compareDifferencesAfterQuoteLaneChanges = (proNumber, laneBefore, laneAfter) => makeRequest(
  authFetch.get(`/api/Orders/${proNumber}/compareQuoteLaneChanges?&afterId=${laneAfter}${laneBefore != null ? `&beforeId=${laneBefore}` : ''}`),
);

export const getFieldsVisibleStatuses = () => makeRequest(
  authFetch.get('api/Orders/fields'),
);